"use client";

import dynamic from "next/dynamic";
import { Loader2 } from "lucide-react";

/**
 * TopicTrendChart 的懒加载封装。
 *
 * 原 TopicTrendChart 依赖 recharts (~360KB),被 topic/[id] / city/[name] /
 * celebrity/[name] 等详情页直接 import,把每个详情页 First Load 都推到 ~300KB。
 * 详情页一打开就有图表(LCP 区域之外),但用户首屏关注的是顶部信息卡,
 * 图表可以晚到 ~200ms 而不影响感知。改 dynamic + ssr:false:
 *   - 详情页 First Load -60~80KB
 *   - 服务端不再渲染图表骨架(避免 Radix Sheet/Dialog 内的 WebKit hover 抖动)
 *   - 用户感知:loading skeleton → 真实图表,无界面退步
 */
const TopicTrendChartImpl = dynamic(
  () => import("./topic-trend-chart").then((m) => ({ default: m.TopicTrendChart })),
  {
    ssr: false,
    loading: () => (
      <div className="flex items-center justify-center bg-muted/20 rounded-md" style={{ height: 300 }}>
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      </div>
    ),
  }
);

export interface TopicTrendChartLazyProps {
  data: { timeid: number; timestamp: Date; rank: number; hotindex: number }[];
}

export function TopicTrendChart(props: TopicTrendChartLazyProps) {
  return <TopicTrendChartImpl {...props} />;
}
